import { PreferredContactMethod } from "@remi/enums/preferred-contact-method";
import { RnEnvelope, RnMessage, RnPhone, RnStarFilled } from "@remi/icons/next";

import { usePerson } from "~/hooks/usePerson";
import { CallButton } from "./CallButton";
import { EmailButton } from "./EmailButton";
import { TextButton } from "./TextButton";

interface ContactMethodButtonsProps {
  personId: string;
}

export const ContactMethodButtons = ({ personId }: ContactMethodButtonsProps) => {
  const { data: person } = usePerson(personId);

  if (!person) {
    return null;
  }

  const preferredContactMethod = person.contact.preferredContactMethod;

  return (
    <div className="flex w-full flex-row gap-1 p-4 pt-0">
      <TextButton
        fullWidth
        icon={<RnMessage />}
        variant="secondary"
        personId={personId}
        number={person.primaryPhone?.number}
        endIcon={
          preferredContactMethod === PreferredContactMethod.TEXT && <RnStarFilled className="text-icon-yellow" />
        }
      >
        Text
      </TextButton>
      <CallButton
        className="w-full"
        icon={<RnPhone />}
        variant="secondary"
        number={person.primaryPhone?.number}
        endIcon={
          preferredContactMethod === PreferredContactMethod.CALL && <RnStarFilled className="text-icon-yellow" />
        }
      >
        Call
      </CallButton>
      <EmailButton
        className="w-full"
        icon={<RnEnvelope />}
        variant="secondary"
        email={person.primaryEmailAddress?.emailAddress}
        endIcon={
          preferredContactMethod === PreferredContactMethod.EMAIL && <RnStarFilled className="text-icon-yellow" />
        }
      >
        Email
      </EmailButton>
    </div>
  );
};
